var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("SeaExport.BookingAudit"),
        width: _vm.$selectByLang("620px", "660px"),
        "custom-class": "cargo-form-dialog",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: _vm.handleClose
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "cargo-form",
          attrs: {
            "label-width": _vm.$selectByLang("100px", "120px"),
            "label-position": "left"
          }
        },
        [
          _vm.isDifferentJobOrBusinessFieldValues
            ? _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "auto-width",
                          attrs: { "label-width": "0" }
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-warning",
                            staticStyle: {
                              color: "#e6a23c",
                              "margin-left": "5px"
                            }
                          }),
                          _c("span", { staticStyle: { "font-size": "12px" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "Message.DifferentJobOrBusinessFieldValues"
                                )
                              )
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "required",
                      attrs: {
                        label: _vm.$t("SeaExport.OperationCompany") + "："
                      }
                    },
                    [
                      _c("cargo-office-select", {
                        attrs: {
                          clearable: false,
                          "have-hq": false,
                          "office-id": Number(_vm.job.opOffice),
                          "tag-name": "code",
                          tooltip: ""
                        },
                        on: {
                          change: function(p) {
                            _vm.job.opOffice = p.value
                            _vm.officeChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Operation") + "：" } },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          "method-params": {
                            officeId: _vm.job.opOffice,
                            category: "role",
                            shape: "op"
                          },
                          "default-value": _vm.job.op || "",
                          placeholder: _vm.differentForm.op
                            ? _vm.$t("CargoMsg.Cargo_keyWordsTip")
                            : _vm.$t("Message.PreserveOriginalValue") +
                              _vm.$t("SeaExport.Operation")
                        },
                        on: {
                          change: function(p) {
                            _vm.job.op = p.value
                            _vm.differentForm.op = true
                            _vm.opChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      class: _vm.isBatchUpdate ? "" : "required",
                      attrs: {
                        label: _vm.$t("SeaExport.OperationDepartment") + "："
                      }
                    },
                    [
                      _c("cargo-department-select", {
                        attrs: {
                          "office-id":
                            Number(_vm.job.opOffice) ||
                            _vm.$store.getters.currentOfficeId,
                          "department-id": Number(_vm.job.opDepartment),
                          placeholder: _vm.differentForm.opDepartment
                            ? _vm.$t("CargoMsg.Cargo_keyWordsTip")
                            : _vm.$t("Message.PreserveOriginalValue") +
                              _vm.$t("SeaExport.OperationDepartment")
                        },
                        on: {
                          change: function(p) {
                            _vm.job.opDepartment = p.value
                            _vm.differentForm.opDepartment = true
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.CustomerService") + "："
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        ref: "csr",
                        attrs: {
                          "method-params": {
                            officeId:
                              _vm.job.salesOffice === 1
                                ? _vm.job.opOffice
                                : _vm.job.salesOffice,
                            category: "role",
                            shape: "csr"
                          },
                          "default-value": _vm.job.csr || "",
                          placeholder: _vm.differentForm.csr
                            ? _vm.$t("CargoMsg.Cargo_keyWordsTip")
                            : _vm.$t("Message.PreserveOriginalValue") +
                              _vm.$t("SeaExport.CustomerService")
                        },
                        on: {
                          change: function(p) {
                            _vm.job.csr = p.value
                            _vm.differentForm.csr = true
                            _vm.csrChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Documents") + "：" } },
                    [
                      _c("cargo-user-select", {
                        ref: "dc",
                        attrs: {
                          "method-params": {
                            officeId: _vm.job.opOffice,
                            category: "role",
                            shape: "doc"
                          },
                          "default-value": _vm.job.dc || "",
                          placeholder: _vm.differentForm.dc
                            ? _vm.$t("CargoMsg.Cargo_keyWordsTip")
                            : _vm.$t("Message.PreserveOriginalValue") +
                              _vm.$t("SeaExport.Documents")
                        },
                        on: {
                          change: function(p) {
                            _vm.job.dc = p.value
                            _vm.differentForm.dc = true
                            _vm.dcChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.BookingAgent") + "：" }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          filterable: "",
                          "method-params": {
                            bookingAgent: true,
                            companyLob: "airExport",
                            active: true
                          },
                          "default-value": _vm.job.bookingAgent || "",
                          placeholder: _vm.differentForm.bookingAgent
                            ? _vm.$t("CargoMsg.Cargo_keyWordsTip")
                            : _vm.$t("Message.PreserveOriginalValue") +
                              _vm.$t("SeaExport.BookingAgent")
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.bookingAgent = p.value
                            _vm.differentForm.bookingAgent = true
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isAddUserDefinedRoles,
                          expression: "isAddUserDefinedRoles"
                        }
                      ],
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_userDefinedRole1") + "："
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId1",
                        attrs: {
                          no: "24",
                          "method-params": {
                            officeId: _vm.job.opOffice,
                            category: "role",
                            shape: "userDefinedRole1"
                          },
                          "default-value": _vm.job.userDefinedRoleId1 || "",
                          placeholder: _vm.differentForm.userDefinedRoleId1
                            ? _vm.$t("CargoMsg.Cargo_keyWordsTip")
                            : _vm.$t("Message.PreserveOriginalValue") +
                              _vm.$t("CargoMsg.Cargo_userDefinedRole1")
                        },
                        on: {
                          change: function(p) {
                            _vm.job.userDefinedRoleId1 = p.value
                            _vm.differentForm.userDefinedRoleId1 = true
                            _vm.userDefinedRole1ChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isAddUserDefinedRoles,
                          expression: "isAddUserDefinedRoles"
                        }
                      ],
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_userDefinedRole2") + "："
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId2",
                        attrs: {
                          no: "25",
                          "method-params": {
                            officeId: _vm.job.opOffice,
                            category: "role",
                            shape: "userDefinedRole2"
                          },
                          "default-value": _vm.job.userDefinedRoleId2 || "",
                          placeholder: _vm.differentForm.userDefinedRoleId2
                            ? _vm.$t("CargoMsg.Cargo_keyWordsTip")
                            : _vm.$t("Message.PreserveOriginalValue") +
                              _vm.$t("CargoMsg.Cargo_userDefinedRole2")
                        },
                        on: {
                          change: function(p) {
                            _vm.job.userDefinedRoleId2 = p.value
                            _vm.differentForm.userDefinedRoleId2 = true
                            _vm.userDefinedRole2ChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Remarks") + "：" } },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea", rows: 2 },
                        model: {
                          value: _vm.bookingAuditRemark,
                          callback: function($$v) {
                            _vm.bookingAuditRemark = $$v
                          },
                          expression: "bookingAuditRemark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "span",
        {
          staticStyle: { padding: "10px" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Confirm")))]
          ),
          _c("el-button", { on: { click: _vm.handleClose } }, [
            _vm._v(_vm._s(_vm.$t("SeaExport.Cancel")))
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }